import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import {
  Home,
  Database,
  Bot,
  Users,
  Settings,
  BarChart3,
  Menu,
  X,
  Package,
  Mail,
  DollarSign,
  Cog,
  Shield,
  Workflow
} from 'lucide-react'
import { useState } from 'react'

const navItems = [
  { to: '/', icon: Home, label: 'Dashboard' },
  { to: '/knowledge-bases', icon: Database, label: 'Knowledge Bases' },
  { to: '/agents', icon: Bot, label: 'Agents' },
  { to: '/workflows', icon: Workflow, label: 'Workflows' },
  { to: '/artifacts', icon: Package, label: 'Artifacts' },
  { to: '/users', icon: Users, label: 'Users' },
  { to: '/credit-tracking', icon: DollarSign, label: 'Credit Tracking' },
  { to: '/service-definitions', icon: Cog, label: 'Service Definitions' },
  { to: '/consent-policies', icon: Shield, label: 'Consent Policies' },
  { to: '/mailing-list', icon: Mail, label: 'Mailing List' },
  { to: '/platform-settings', icon: Settings, label: 'Platform Settings' },
  { to: '/analytics', icon: BarChart3, label: 'Analytics', future: true },
]

export function Sidebar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <>
      {/* Mobile menu button */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 rounded-md bg-card shadow-md border border-border"
        >
          {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-background/80 backdrop-blur-sm z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={cn(
          "fixed lg:static inset-y-0 left-0 z-40 w-64 bg-card shadow-lg transform transition-transform lg:transform-none flex-shrink-0 h-screen",
          isMobileMenuOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        )}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center justify-center h-16 bg-primary">
            <h1 className="text-xl font-bold text-primary-foreground">
              Ponder Admin
            </h1>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setIsMobileMenuOpen(false)}
                className={({ isActive }) =>
                  cn(
                    "flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors",
                    isActive
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                    item.future && "opacity-50 cursor-not-allowed"
                  )
                }
              >
                <item.icon className="mr-3 h-5 w-5" />
                {item.label}
                {item.future && (
                  <span className="ml-auto text-xs bg-muted px-2 py-1 rounded">
                    Future
                  </span>
                )}
              </NavLink>
            ))}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-border">
            <p className="text-xs text-muted-foreground text-center">
              Admin Panel v1.0
            </p>
          </div>
        </div>
      </aside>
    </>
  )
}